/**
 * INSURANCE DOMAIN CONFIGURATION
 * Cấu hình cho lĩnh vực Bảo hiểm
 */
export const domainConfig = {
  // === BASIC INFO ===
  id: "insurance",
  name: "Bảo hiểm",
  icon: "🛡️",
  description: "Tạo nội dung marketing cho các sản phẩm và dịch vụ bảo hiểm",

  // === PROJECT TYPES ===
  projectTypes: {
    "Bảo hiểm nhân thọ": 1,
    "Bảo hiểm sức khỏe": 2,
    "Bảo hiểm xe cộ": 3,
    "Bảo hiểm tài sản": 4,
    "Bảo hiểm du lịch": 5,
    "Bảo hiểm doanh nghiệp": 6,
    "Bảo hiểm tai nạn": 7,
    "Bảo hiểm hưu trí": 8,
    "Bảo hiểm giáo dục": 9,
    "Bảo hiểm nông nghiệp": 10,
    "Bảo hiểm trách nhiệm": 11,
    "Bảo hiểm vi mô": 12,
  },

  // === CONTENT TYPES ===
  contentTypes: {
    "Giới thiệu sản phẩm": 1,
    "Quyền lợi bảo hiểm": 2,
    "Hướng dẫn mua bảo hiểm": 3,
    "Quy trình bồi thường": 4,
    "Câu chuyện khách hàng": 5,
    "So sánh gói bảo hiểm": 6,
    "Tips quản lý rủi ro": 7,
    "Khuyến mãi/Ưu đãi": 8,
    "Tin tức bảo hiểm": 9,
    "FAQ thường gặp": 10,
    "Chính sách điều khoản": 11,
    "Tư vấn bảo hiểm": 12,
  },

  // === PUBLISHING PLATFORMS (Optional) ===
  publishingPlatforms: {
    // Để trống sẽ dùng shared platforms
  },

  // === DEFAULT VALUES ===
  defaults: {
    projectType: "Bảo hiểm sức khỏe",
    contentType: "Giới thiệu sản phẩm",
    postLength: "Trung bình",
    postStyles: ["Chuyên nghiệp", "Đáng tin cậy"],
  },

  // === UI LABELS ===
  labels: {
    projectTypeLabel: "Loại bảo hiểm",
    contentTypeLabel: "Loại nội dung",
    projectInfoLabel: "Thông tin sản phẩm bảo hiểm",
    projectInfoPlaceholder:
      "Nhập thông tin chi tiết về sản phẩm bảo hiểm:\n- Tên gói bảo hiểm\n- Quyền lợi chính\n- Mức phí bảo hiểm\n- Điều kiện tham gia\n- Thời hạn bảo hiểm\n- Quy trình bồi thường...",
    targetCustomerLabel: "Đối tượng khách hàng",
    targetCustomerPlaceholder:
      "Mô tả đối tượng khách hàng: độ tuổi, nghề nghiệp, thu nhập, nhu cầu bảo hiểm...",
  },

  // === DOMAIN-SPECIFIC SETTINGS ===
  settings: {
    requiresLocation: false, // Dịch vụ có thể online
    requiresPrice: true, // Phí bảo hiểm quan trọng
    requiresLicense: true, // Cần giấy phép kinh doanh bảo hiểm
    requiresCompliance: true, // Tuân thủ quy định của Bộ Tài chính
    requiresAge: true, // Độ tuổi quan trọng trong bảo hiểm
    requiresHealthInfo: false, // Tùy loại bảo hiểm
  },
};
